/**
 * This file is used to override price display when a promo is active.
 * @see https://onnitlabs.atlassian.net/wiki/spaces/DEV/pages/3666444292/Shopify+Subscription+Discount+For+Initial+Order
 */

var oneTimePromoSkus = [];
var subscriptionPromoSkus = [...oneTimePromoSkus,
// TH is still on its own 30% Subscription Promo only.
'20000062',
//TH 30
'20000075',
//TH 60
'20000076' //TH 90
];
export var promoConfig = {
  /*******
   THIS SHOULD ONLY BE ACTIVE DURING SUBSCRIPTION PROMOS WHEN
   THE FIRST ORDER DISCOUNT IS SET TO 0 IN ORDERGROOVE AND THERE
   ARE AUTOMATIC DISCOUNTS SETUP IN SHOPIFY FOR THE FIRST ORDER.
   *******/
  isPromoActive: true,
  promoDiscountPercent: 30,
  defaultDiscountPercent: 15,
  oneTimePromoSkus,
  subscriptionPromoSkus
};

/**
 * Utils
 */
export function calculateDiscountedPrice(priceInCents, discountPercent) {
  var discountAmount = priceInCents * (discountPercent / 100);
  // When discounting a price in cents, we can be left with decimal places. Math.trunc removes any
  // decimal places without rounding which seems to match how Shopify applies discounts as the
  // resulting price matches what is in the cart and checkout.
  var discountedPriceInCents = priceInCents - Math.trunc(discountAmount);
  return formatCentsToDollars(discountedPriceInCents);
}
export function formatCentsToDollars(priceInCents) {
  var priceInDollars = priceInCents / 100;
  return '$' + priceInDollars.toFixed(2);
}